const firebaseConfig = {
    apiKey: "AIzaSyBnG_1L7fEOEgGkzax3Nrc3IWnFt4bOjVc",
    authDomain: "ema-john-simple-e5553.firebaseapp.com",
    projectId: "ema-john-simple-e5553",
    storageBucket: "ema-john-simple-e5553.appspot.com",
    messagingSenderId: "1001993257386",
    appId: "1:1001993257386:web:0d53e26e66a048f646abd3"
  };

  export default firebaseConfig;